<template>
  <v-container
    fluid
    class="container-bg rounded elevation-3">
    <v-row>
      <v-col
        cols="12"
        md="auto">
        <h2>Distributors</h2>
      </v-col>
      <v-spacer />
      <v-col
        cols="12"
        md="auto">
        <v-select
          v-model="query.sortBy"
          :items="sortByOptions"
          item-text="text"
          item-value="value"
          label="เรียงจาก"
          color="secondary"
          outlined
          dense
          hide-details>
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="auto">
        <v-select
          v-model="query.sortOrder"
          :items="sortOrderOptions"
          item-text="text"
          item-value="value"
          label="เรียงลำดับ"
          color="secondary"
          outlined
          dense
          hide-details>
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="auto">
        <v-select
          v-model="query.brand"
          :items="brands"
          label="Brand"
          item-text="text"
          item-value="value"
          :loading="loading"
          :menu-props="{ offsetY: true }"
          color="secondary"
          outlined
          dense
          hide-details>
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="auto">
        <div class="d-flex flex-row justify-end align-center">
          <search-box
            v-model="query.search"
            @on-search="getItems(true)" />
          <v-btn
            color="success"
            :disabled="loading"
            to="/exportation/distributors/create"
            class="ml-2 mb-1">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            color="success"
            :disabled="loading"
            class="ml-2 mb-1"
            @click="exportCsv()">
            <v-icon>mdi-table-arrow-up</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="query.limit"
          :loading="loading"
          hide-default-footer>
          <template #[`item.firstName`]="{ item }">
            {{ item.firstName || '-' }}
          </template>
          <template #[`item.lastName`]="{ item }">
            {{ item.lastName || '-' }}
          </template>
          <template #[`item.tel`]="{ item }">
            {{ item.tel || '-' }}
          </template>
          <template #[`item.email`]="{ item }">
            {{ item.email || '-' }}
          </template>
          <template #[`item.country`]="{ item }">
            {{ getShippingCountry(item.country) || '-' }}
          </template>
          <template #[`item.brand`]="{ item }">
            {{ item.brand || '-' }}
          </template>
          <template #[`item.action`]="{ item }">
            <div class="d-flex flex-row justify-center align-center">
              <v-btn
                color="secondary"
                small
                icon
                :to="`/exportation/distributors/${item.id}`">
                <v-icon small>
                  mdi-square-edit-outline
                </v-icon>
              </v-btn>
              <v-btn
                color="error"
                small
                icon
                @click="confirmRemoveItem(item)">
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12">
        <v-pagination
          v-model="query.page"
          :length="pageCount"
          :disabled="loading"
          total-visible="7"
          color="secondary" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { ExportToCsv } from 'export-to-csv'
import SearchBox from '@/components/SearchBox.vue'
import ProductAttributeProvider from '@/resources/ProductAttributeProvider'
import DistributorsProvider from '@/resources/DistributorsProvider'
import { getRole } from '@/assets/js/Authentication'
import ShippingCountries from '@/assets/json/ShippingCountries.json'

const ProductAttributeService = new ProductAttributeProvider()
const DistributorsService = new DistributorsProvider()

export default {
  components: {
    SearchBox
  },
  data () {
    return {
      headers: [
        {
          text: 'ชื่อผู้ใช้งาน',
          value: 'username',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ชื่อ',
          value: 'firstName',
          sortable: false,
          align: 'center'
        },
        {
          text: 'นามสกุล',
          value: 'lastName',
          sortable: false,
          align: 'center'
        },
        {
          text: 'เบอร์โทร',
          value: 'tel',
          sortable: false,
          align: 'center'
        },
        {
          text: 'อีเมล',
          value: 'email',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ประเทศ',
          value: 'country',
          sortable: false,
          align: 'center'
        },
        {
          text: 'แบรนด์',
          value: 'brand',
          sortable: false,
          align: 'center'
        },
        {
          text: 'ตัวเลือก',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      items: [],
      brands: [
        {
          text: 'All',
          value: null
        }
      ],
      sortByOptions: [
        {
          text: 'ชื่อ',
          value: 'firstName'
        },
        {
          text: 'วันที่สร้าง',
          value: 'createdAt'
        },
        {
          text: 'วันที่แก้ไข',
          value: 'updatedAt'
        }
      ],
      sortOrderOptions: [
        {
          text: 'A-Z',
          value: 'asc'
        },
        {
          text: 'Z-A',
          value: 'desc'
        }
      ],
      query: {
        page: 1,
        limit: 10,
        role: null,
        status: null,
        sortBy: 'createdAt',
        sortOrder: 'asc',
        search: '',
        brand: null
      },
      pageCount: 0,
      loading: false
    }
  },
  computed: {
    isDeveloper () {
      return getRole() === 'developer'
    }
  },
  watch: {
    'query.page': {
      handler () {
        this.getItems()
      },
      deep: true
    },
    'query.sortBy': {
      handler () {
        this.getItems(true)
      },
      deep: true
    },
    'query.sortOrder': {
      handler () {
        this.getItems(true)
      },
      deep: true
    },
    'query.brand': {
      handler () {
        this.getItems(true)
      },
      deep: true
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    ...mapActions({
      setSnackbar: 'Components/setSnackbar',
      setModal: 'Components/setModal'
    }),
    async initialize () {
      try {
        this.loading = true

        await this.getBrands()
        await this.getItems(true)
      } catch (error) {
        console.error('initialize', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `[INITIALIZE-ERROR]: ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async getBrands () {
      try {
        const { data } = await ProductAttributeService.getProductAttribute('brands', {
          limit: 9999,
          sortBy: 'createdAt',
          sortOrder: 'asc'
        })

        this.brands = [
          {
            text: 'All',
            value: null
          },
          ...data.results.map((re) => ({
            text: re.name,
            value: re.name
          }))
        ]
      } catch (error) {
        console.error('getBrands', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `[GET-BRANDS-ERROR]: ${error.message}`,
          type: 'error'
        })
      }
    },
    getShippingCountry (code) {
      return ShippingCountries.find((country) => country.code === code)?.country || code
    },
    async getItems (isClear = false) {
      try {
        this.loading = true

        if (isClear) {
          this.query.page = 1
          this.items = []
        }

        const { data } = await DistributorsService.getItems({
          page: this.query.page,
          limit: this.query.limit,
          search: this.query.search,
          sortBy: this.query.sortBy,
          sortOrder: this.query.sortOrder,
          brand: this.query.brand
        })

        this.items = data.results
        this.pageCount = data.pages
      } catch (error) {
        console.error('getItems', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    confirmRemoveItem (item) {
      this.setModal({
        value: true,
        title: 'Remove Item',
        message: `Do you want to remove ${item.firstName} ${item.lastName}?`,
        confirmText: 'Remove',
        confirmType: 'error',
        cancelType: '',
        cancelText: 'Cancel',
        onConfirm: () => this.removeItem(item.id)
      })
    },
    async removeItem (id) {
      try {
        this.loading = true

        await DistributorsService.deleteItem(id)

        this.getItems(true)
      } catch (error) {
        console.error('removeItem', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async exportCsv () {
      try {
        this.loading = true

        const { data } = await DistributorsService.getItems({
          page: 1,
          limit: 999999,
          search: this.query.search,
          sortBy: this.query.sortBy,
          sortOrder: this.query.sortOrder,
          brand: this.query.brand
        })

        const mapped = data.results.map((item) => ({
          ชื่อผู้ใช้งาน: item.username,
          ชื่อ: item.firstName,
          นามสกุล: item.lastName,
          เบอร์โทร: item.tel,
          อีเมล: item.email,
          ประเทศ: item.country,
          แบรนด์: item.brand
        }))

        const options = {
          filename: `distributors-${this.$dayjs().format('YYYY-MM-DD')}`,
          showLabels: true,
          useKeysAsHeaders: true
        }

        const csvExporter = new ExportToCsv(options)
        csvExporter.generateCsv(mapped)
      } catch (error) {
        console.error('exportCsv', error)
        this.setSnackbar({
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.container-bg {
  background-color: white;
}
</style>
